var map = {
	"./MONKEYMAN.jpg": 709,
	"./Monokuma.jpg": 433,
	"./Nagito.jpg": 720,
	"./OrangeNOrange.jpg": 952,
	"./Papyrus.jpg": 14,
	"./RTXVillager.jpg": 198,
	"./Sans.jpg": 274,
	"./SansDog.jpg": 508,
	"./Tinnocky.jpg": 177,
	"./background.jpg": 942,
	"./default.jpg": 161,
	"./sky.jpg": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;